import { getConfiguration, oddToString, getCurrencyValue, formatDate, formatDateWithMonth, getPrematchAggs, getSplitDesc, formatDateWithWeekDay } from './utils';
import { parseBetsData } from './parseBetsData';
import { getLabel } from '../InitData';
import { systemCode, xs_languageCode } from '..';
import { getUrlPath } from './parseTournamentsByDate';
import { getUrlPathSeo, getUrlPathSeoSettings } from './data';

function parseSoffiata(data) {
    const conf = getConfiguration().cs;
    
    const soffiata = data.map(el => {
        const events = el.avs.map(avv => {
            // Recupera l'aggregata corrente
            const aggData = getPrematchAggs(avv.cs, avv.ag);
            // Trova la scommessa nell'aggregata
            const aggregata = aggData.scommesse.find(bet => bet.id === avv.sc.cs);
            // Crea una mappa id -> esito con esiti dell'aggregata
            const oddsById = {};
            aggregata.odds.forEach(odd => {
                oddsById[odd.id] = odd;
            });

            const odds = avv.sc.eqs.map(odd => {
            	let desc = '';
            	if (aggregata.odds.length > 0) {
            		const aggOdd = oddsById[odd.ce];
            		if(aggOdd != null){
            			desc = aggOdd.desc;            			
            		}
            	} else {
            		// dynamic draw list market
            		desc = odd.d;
            	}
                // valore della quota
                let oddVal = odd.q;
                if(avv.sc.qps && avv.sc.qps.vl){
                	const skinKeyPers = `${systemCode}:${avv.sc.cs}:${avv.sc.h}:${odd.ce}`;
                	let keyMapGroupCode = null;
            		let keyMapShopCode = null;
            		
            		if(window.appConfig.TERMINAL_AGENCY){
            			const operator = window.getLoggedParamsFromLS();
            			if(operator){
            				if(operator.groupId){
            					const groupKey = "GRP-" + operator.groupId;
            					keyMapGroupCode = `${groupKey}:${avv.sc.cs}:${avv.sc.h}:${odd.ce}`;
            				}
            				const servicesMap = operator.servicesMap? operator.servicesMap: operator.hash_servizi;
            				const cnPvend = servicesMap['SPORT'];
            				if(cnPvend){
            					const cn = cnPvend.split("/")[0];
            					const pvend = cnPvend.split("/")[1];
            					const cnPvendKey = cn + "_" + pvend;
            					keyMapShopCode = `${cnPvendKey}:${avv.sc.cs}:${avv.sc.h}:${odd.ce}`;
            				}
            			}
            		}
            		else if(window.appConfig.SELF_CASHIER){
            			const cashier = window.getVoucherParamsFromLS();
              			if(cashier){
            				if(cashier.groupId){
            					const groupKey = "GRP-" + cashier.groupId;
            					keyMapGroupCode = `${groupKey}:${avv.sc.cs}:${avv.sc.h}:${odd.ce}`;
            				}
            				const servicesMap = cashier.servicesMap? cashier.servicesMap: cashier.hash_servizi;
            				const cnPvend = servicesMap['SPORT'];
            				if(cnPvend){
            					const cn = cnPvend.split("/")[0];
            					const pvend = cnPvend.split("/")[1];
            					const cnPvendKey = cn + "_" + pvend;
            					keyMapShopCode = `${cnPvendKey}:${avv.sc.cs}:${avv.sc.h}:${odd.ce}`;
            				}
            			}
            		}
                	
            		let customizedOdd = null;
            		//high priority: shop
            		if(keyMapShopCode && avv.sc.qps.vl[keyMapShopCode] !== null){
            			customizedOdd = avv.sc.qps.vl[keyMapShopCode];
            		}
            		
            		// less priority: group of this shop
            		if(keyMapGroupCode && avv.sc.qps.vl[keyMapGroupCode] !== null && !customizedOdd){
            			customizedOdd = avv.sc.qps.vl[keyMapGroupCode];
            		}
            		
            		// lowest priority: skin customization
            		if (avv.sc.qps.vl[skinKeyPers] !== null && !customizedOdd) {
            			customizedOdd = avv.sc.qps.vl[skinKeyPers];
            		}
            		if(customizedOdd){
            			oddVal = customizedOdd;
            		}
                }
                return {
                    id: odd.ce,
                    value: oddVal > 100 ? oddToString(oddVal): null,
                    rawValue: oddVal > 100 ? oddVal: null,
                    desc,
                };
            });
            const scommessa = {
                id: avv.sc.cs,
                desc: aggregata.desc,
                handicap: avv.sc.h,
                odds
            };
    
            const [team1, team2] = getSplitDesc(avv.da);
            return {
                alias: avv.al,
                id: avv.bid,
                desc: avv.da,
                team1,
                team2,
                date: formatDateWithMonth(avv.ts).dayMonthTime,
                time: formatDate(avv.ts).time,
                pal: avv.p,
                avv: avv.a,
                categoryRef: avv.cc,
                descSport: avv.ds,
                descTournament: avv.dt,
                isLive: false,
                selectedOdd: avv.ces,
                scommessa,
                sportRef: avv.cs,
                tournamentRef: avv.ct,
                timestamp: avv.ts,
                lsportWidgetId: avv.lswid,
                uniqueId: `${avv.cs}_${avv.cc}_${avv.ct}_${avv.bid}`
            };
        });
    
        return {
            totalAmount: getCurrencyValue(el.it, conf.m, conf.nd, conf.ct),
            totalAmountRaw: el.it,
            totalOdds: oddToString(el.qt),
            totalWinnings: getCurrencyValue(el.vt, conf.m, conf.nd, conf.ct),
            events
        };
    });
    
    if (soffiata[0]) {
        soffiata[0].desc = getLabel('prematch_page.widget.la_soffiata.favorita');
    }
    if (soffiata[1]) {
        soffiata[1].desc = getLabel('prematch_page.widget.la_soffiata.blindata');
    }
    if (soffiata[2]) {
        soffiata[2].desc = getLabel('prematch_page.widget.la_soffiata.sbancatutto');
    }

    return soffiata;
}

function parseTopMatches(data) {
    const matches = [];
    data.forEach(m => {
        if (m.scs == null) {
            if (m.sc == null) {
                return;
            } else {
                m.scs = [m.sc];
            }
        }

        const matchData = {
            sportRef: m.cs,
            tournamentRef: m.ct,
            pal: m.p,
            avv: m.a,
            id: m.bid,
            desc: m.da,
            uniqueId: m.bid,
            alias: m.al,
            sportDesc: m.ds,
            tournamentDesc: m.dt,
            timestamp: m.ts,
            lsportWidgetId: m.lswid,
            urlPath: getUrlPath({uniqueId: `${m.cs}_${m.cc}_${m.ct}`, urlPath: `${m.ds}/${m.dt}`}, m, m.da),
            urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seom}),
            urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoma})
        };

        const ag = m.ag;
        const betsData = parseBetsData(matchData, [ag], ag, m.scs, false, false);

        const [team1, team2] = getSplitDesc(m.da);

        function getUrlPath(tournament, match, desc) {
            let url;
            try {
                desc = desc.replace(/-/g, 'vs').replace(/\s+/g, '-').replace(/\//g, '-');
                url = `${tournament.urlPath}/${desc}_${tournament.uniqueId}_${match.p}_${match.a}`;
                return url.toLocaleLowerCase();
            }catch(err) {
                console.error(err);
                return url;
            }
        }
        const formattedDate = formatDateWithMonth(m.ts);
        matches.push({
            alias: m.al,
            avv: m.a,
            ...betsData,
            categoryDesc: m.dc,
            categoryIcon: m.icc,
            categoryRef: m.cc,
            date: formattedDate.dayMonthTime,
            dateShort: formattedDate.dayMonthShort,
            desc: m.da,
            id: m.bid,
            isLive: false,
            lsportWidgetId: m.lswid,
            pal: m.p,
            plus: m.pl,
            scommessa: betsData.bets[0],
            sportDesc: m.ds,
            sportIcon: m.ics,
            sportRef: m.cs,
            team1,
            team2,
            time: formatDate(m.ts).time,
            timestampDB: m.ts,
            tournamentDesc: m.dt,
            tournamentRef: m.ct,
            uniqueId: `${m.cs}_${m.cc}_${m.ct}_${m.bid}`,
            urlPath: getUrlPath({uniqueId: `${m.cs}_${m.cc}_${m.ct}`, urlPath: `${m.ds}/${m.dt}`}, m, m.da),
            urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seom}),
            urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoma})
        });
    })
    
    function bySportAndTimestamp(a, b) {
        if (a.sportRef !== b.sportRef) {
            return a.sportRef - b.sportRef;
        }
        return a.timestampDB.localeCompare(b.timestampDB);
    }

    return matches.sort(bySportAndTimestamp);
}

function parseLastMinute(data) {
    const descBySport = {};
    const matchesBySport = {};
    const sports = [];
    for (let key in data) {
        if (data[key].avs.length === 0) {
            continue;
        }

        const ag = data[key].ag;
        const sportDesc = data[key].ds;
        descBySport[key] = sportDesc;
        sports.push(key);
        matchesBySport[key] = data[key].avs.map(m => {
            const desc = m.dsl[xs_languageCode];
        	const tournamentDesc = data[key].dts[m.it];
            const matchData = {
                sportRef: key,
                tournamentRef: m.it,
                pal: m.p,
                avv: m.a,
                id: m.bid,
                desc,
                uniqueId: m.bid,
                alias: m.al,
                sportDesc: sportDesc,
                tournamentDesc: tournamentDesc,
                timestamp: m.ts,
                lsportWidgetId: m.lswid,
                urlPath: getUrlPath({uniqueId: `${m.is}_${m.ic}_${m.it}`, urlPath: `${sportDesc}/${tournamentDesc}`}, m, desc),
                urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seom}),
                urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoma})
            };
            const betsData = parseBetsData(matchData, [ag], ag, m.scs, m.lv, false);

            const [team1, team2] = getSplitDesc(desc);
            return {
                alias: m.al,
                avv: m.a,
                categoryRef: m.ic,
                date: formatDateWithWeekDay(m.ts).dayMonth,
                desc: desc,
                fullDesc: `${sportDesc} - ${tournamentDesc}`,
                id: m.bid,
                isLive: m.lv,
                lsportWidgetId: m.lswid,
                openMacrogruppo: m.om,
                pal: m.p,
                plus: m.pl,
                score: m.scr,
                show: m.sh,
                sportDesc: sportDesc,
                sportRef: key,
                team1,
                team2,
                time: formatDate(m.ts).time,
                timestampDB: m.ts,
                tournamentDesc: tournamentDesc, 
                tournamentRef: m.it,
                uniqueId: `${key}_${m.ic}_${m.it}_${m.bid}`,
                urlPath: getUrlPath({uniqueId: `${key}_${m.ic}_${m.it}`, urlPath: `${sportDesc}/${tournamentDesc}`}, m, desc),
                urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seom}),
                urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoma}),
                ...betsData
            };
        });
    }

    return {
        sports,
        matchesBySport,
        descBySport
    };
}

function parseHighlights(data) {
    const matches = [];
    data.forEach(m => {
        if (m.scs == null) {
            return;
        }



        const matchData = {
            sportRef: m.cs,
            tournamentRef: m.ct,
            pal: m.p,
            avv: m.a,
            id: m.bid,
            desc: m.da,
            uniqueId: m.bid,
            alias: m.al,
            sportDesc: m.ds,
            tournamentDesc: m.dt,
            timestamp: m.ts,
            lsportWidgetId: m.lswid,
            urlPath: getUrlPath({uniqueId: `${m.cs}_${m.cc}_${m.ct}`, urlPath: `${m.ds}/${m.dt}`}, m, m.da),
            urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seom}),
            urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoma}),
        };

        const ag = m.ag;
        const betsData = parseBetsData(matchData, [ag], ag, m.scs, false, false);

        const [team1, team2] = getSplitDesc(m.da);
        function getUrlPath(tournament, match, desc) {
            let url;
            try {
                desc = desc.replace(/-/g, 'vs').replace(/\s+/g, '-').replace(/\//g, '-');
                url = `${tournament.urlPath}/${desc}_${tournament.uniqueId}_${match.p}_${match.a}`;
                return url.toLocaleLowerCase();
            } catch(err) {
                console.error(err);
                return url;
            }
        }

        const formattedDate = formatDateWithMonth(m.ts);
        matches.push({
            alias: m.al,
            avv: m.a,
            ...betsData,
            categoryDesc: m.dc,
            categoryIcon: m.icc,
            categoryRef: m.cc,
            date: formattedDate.dayMonthTime,
            dateShort: formattedDate.dayMonthShort,
            desc: m.da,
            id: m.bid,
            isLive: false,
            lsportWidgetId: m.lswid,
            pal: m.p,
            plus: m.pl,
            sportDesc: m.ds,
            sportIcon: m.ics,
            sportRef: m.cs,
            team1,
            team2,
            time: formatDate(m.ts).time,
            timestampDB: m.ts,
            tournamentDesc: m.dt,
            tournamentRef: m.ct,
            urlPath: getUrlPath({uniqueId: `${m.cs}_${m.cc}_${m.ct}`, urlPath: `${m.ds}/${m.dt}`}, m, m.da),
            urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seom}),
            urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoma}),
            title: m.titl,
            midDisclaimer: m.discl,
            topDisclaimer: m.topd,
            bottomDisclaimer: m.botd,
        });
    })
    function byTimestamp(a, b) {
        return a.timestampDB.localeCompare(b.timestampDB);
    }

    return matches.sort(byTimestamp);
}

export function parseWidgetData(data, forceMatchWidget) {
    const conf  = getConfiguration();
    const soffiata = (conf.bwe) && data?.bws?.length > 0 ? parseSoffiata(data.bws) : null;
    const topMatches = (forceMatchWidget || conf.tme) && data?.tms?.length > 0 ? parseTopMatches(data.tms) : null;
    const lastMinute = (forceMatchWidget || conf.lme) && data.lms && Object.keys(data.lms).length > 0? parseLastMinute(data.lms) : null;
    const highlights = data?.hgevs?.evs?.length > 0 ? parseHighlights(data.hgevs.evs) : null;

    return {
        topMatches,
        soffiata,
        lastMinute,
        highlights
    };
}
